<template>
  <div class="remaining-time" :class="layout" ref="remainingTimeRef" v-show="remainingStartMill">
    <div class="remaining">
      <span>{{$t('time-left-title')}}</span>
      <span class="countdown remaining-session-time"> {{ remainingStr }}</span>
    </div>
    <div class="notice">
      {{ getLabelCode('header.timeclockMessage') ?? $t('remaining-time-notice') }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  props: {
    layout: {
      type: String,
      default: ''
    }
  },
  created () {
    this.initRemainingTime()
  },
  computed: {
    ...mapState(['remainingStr', 'remainingStartMill']),
    ...mapGetters(['getLabelCode'])
  },
  methods: {
    ...mapActions(['countNumberInterval']),
    initRemainingTime () {
      if (this.remainingStartMill) {
        this.countNumberInterval()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.remaining-time {
  text-align: center;
  .remaining {
    @include font_color('detail-title');
    .remaining-session-time {
      font-size: 2.25rem;
    }
  }
  .notice {
    margin: 15px 0;
    font-size: 0.9375rem;
  }

  /* 手机端样式 */
  &.mobile {
    width: 100%;
    height: 34px;
    background-color: #cdd2fd;
    margin-bottom: 15px;
    font-size: 1rem;
    .remaining{
      width: 100%;
      height: 100%;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      .remaining-session-time {
        display: inline-block;
        margin-left: 5px;
        font-size: 1rem;
      }
    }
    .notice {
      display: none;
    }
  }
}
</style>
